// GoogleMapsLoader.js
import React from 'react';
import { useLoadScript } from '@react-google-maps/api';

const libraries = ['places'];

const GoogleMapsLoader = ({ children }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyBZUlA6YY8998nbFVsE_VuXZ4JpQRJwgHY',
    libraries
  });

  // Don’t show anything while loading
  if (!isLoaded) return null;

  return <>{children}</>;
};

export default GoogleMapsLoader;
